import { connect } from 'react-redux';
import TranslationProvider from './TranslationProvider';
import { isLoading } from '../../modules/storage/selectors';
import { getData, getLocale } from '../../modules/translation/selectors';
import { fetchTranslationsRequest } from '../../modules/translation/actions';
import { getPreferredLocale } from '../../modules/translation/utils';
const mapState = (state, ownProps) => {
    // Wait until the locale is loaded from the storage to select it
    let locale;
    let translations;
    if (!isLoading(state)) {
        locale =
            getLocale(state) ||
                getPreferredLocale(ownProps.locales) ||
                ownProps.locales[0];
        if (locale) {
            const translationsInState = getData(state)[locale];
            if (translationsInState) {
                translations = translationsInState;
            }
        }
    }
    return {
        locale: locale,
        translations
    };
};
const mapDispatch = (dispatch) => ({
    onFetchTranslations: (locale) => dispatch(fetchTranslationsRequest(locale))
});
export default connect(mapState, mapDispatch)(TranslationProvider);
//# sourceMappingURL=TranslationProvider.container.js.map